import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Form, Label, Input, Col, Row, Alert} from 'reactstrap';
import './CreateStaffMemberModal.css';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

const FIRST_NAME = 'first-name';
const LAST_NAME = 'last-name';
const EMAIL = 'email';


class CreateStaffMemberModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: ''
        }
    }

    render() {
        return (
            <Modal className="staff-member-modal" isOpen={this.props.isOpen && !this.props.loadingOrg} toggle={this.props.onCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <FormWrapper
                successMessage={_.get(this.props.translation, 'org_staff.staff.create_success_message')}
            >
                {this.props.isOrgValidated ? null :
                    <Alert color="warning">{_.get(this.props.translation, 'main.non_validated_org_access_label')}</Alert>}
                <Form onSubmit={this.handleSubmit}>
                    <Row className="modal-form-field-container">
                        <Col sm={3} className="modal-label-container">
                            <Label>{_.get(this.props.translation, sharedLabelsPath.first_name_label) + '*'}</Label>
                        </Col>
                        <Col sm={8}>
                            <Input type="text"
                                   placeholder={`${_.get(this.props.translation, sharedLabelsPath.first_name_label)}`}
                                   required
                                   onChange={this.handleChange(FIRST_NAME)}/>
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={3} className="modal-label-container">
                            <Label>{_.get(this.props.translation, sharedLabelsPath.last_name_label) + '*'}</Label>
                        </Col>
                        <Col sm={8}>
                            <Input type="text"
                                   placeholder={`${_.get(this.props.translation, sharedLabelsPath.last_name_label)}`}
                                   required
                                   onChange={this.handleChange(LAST_NAME)}/>
                        </Col>
                    </Row>
                    <Row className="modal-form-field-container">
                        <Col sm={3} className="modal-label-container">
                            <Label>{_.get(this.props.translation, sharedLabelsPath.email_label) + '*'}</Label>
                        </Col>
                        <Col sm={8}>
                            <Input type="text"
                                   placeholder={`${_.get(this.props.translation, sharedLabelsPath.email_label)}`}
                                   required
                                   onChange={this.handleChange(EMAIL)}/>
                        </Col>
                    </Row>
                    <div className="modal-buttons-container">
                        <Button color="secondary" onClick={this.props.onCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                        <Button className="olive-green-btn" type="submit" disabled={!this.props.isOrgValidated}>
                            {_.get(this.props.translation, 'org_staff.staff.register_button')}
                        </Button>
                    </div>
                </Form>
            </FormWrapper>
        );
    }

    componentDidMount() {
        this.props.onMount();
    }

    handleChange = (inputName) => (e) => {
        switch (inputName) {
            case FIRST_NAME:
                this.setState({firstName: e.target.value});
                break;
            case LAST_NAME:
                this.setState({lastName: e.target.value});
                break;
            case EMAIL:
                this.setState({email: e.target.value});
                break;
            default:
                break;
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        let staffMemberData = {
            email: this.state.email,
            identityAlias: {
                firstName: this.state.firstName,
                lastName: this.state.lastName
            }
        };

        this.props.onStaffMemberCreate(staffMemberData);
    }
}

CreateStaffMemberModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    loadingOrg: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    isOrgValidated: PropTypes.bool,
    toggle: PropTypes.func,
    onStaffMemberCreate: PropTypes.func,
    onMount: PropTypes.func
};

export default CreateStaffMemberModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/staffMemberModal/createStaffMemberModal/CreateStaffMemberModal.js